<template>

  <div class="disclaimer">
    <div class="imageStyle">
      <img src="https://res.jaadee.net/rn/assets/src/Image/Image-xxhdpi/mine/bg_disclaimer.png" alt=""/>
    </div>
    <div class="titleViewStyle">
      <div class="div1">
        <div class="pointStyle">
          <p></p>
        </div>
        <div class="titleStyle">
          <p>翡翠王朝直播仅提供直播服务、技术支持，
            内容提供方应遵守平台规定和协议，不发表违法、违规的内容，违法产生的后果将由内容提供方自行承担。</p>
        </div>
      </div>
      <div class="div1">
        <div class="pointStyle">
          <p></p>
        </div>
        <div class="titleStyle">
          <p>APP上传的内容，版权为发布者与平台方持有，用户不得私自用于非法用途，否则后果自负。</p>
        </div>
      </div>
      <div class="div1">
        <div class="pointStyle">
          <p></p>
        </div>
        <div class="titleStyle">
          <p>本APP有权对内容所有者及发布的内容进行监督。所发表内容不得违反国家法律规定。
            如有违者，本公司有权随时予以删除，并保留与有关部门配合追究的权利。</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Disclaimer"
}
</script>

<style scoped lang="scss">
.disclaimer {
  display: flex;
  background-color: #EDEDF2;
  flex-flow: column nowrap;
  align-items: flex-start;

  .imageStyle {
    margin-top: 0;
    width: 100%;
    height: 2.093rem;
  }
  .titleViewStyle {
    display: flex;
    flex-flow: column;
    background-color: #ffffff;
    border-top-left-radius: 0.18rem;
    border-top-right-radius: 0.18rem;
    margin: -0.35rem 0.26rem 0 0.16rem;
    padding-top: 0.5rem;
    padding-bottom: 0.3rem;
    .div1 {
      display: flex;
      flex-flow: row;
      width: 100%;
      margin-bottom: 0.35rem;
      .pointStyle {
        display: flex;
        align-items:center;
        justify-content: center;
        margin-left: 0.15rem;
        width: 0.34rem;
        height: 0.34rem;
        p {
          background-color: #EABE77;
          border-radius: 0.0335rem;
          width: 0.067rem;
          height: 0.067rem;
        }
      }
      .titleStyle {
        flex: 1;
        p {
          padding-right: 0.3rem;
          text-align: left;
          line-height: 0.34rem;
          font-size: 0.2rem;
        }
      }
    }
  }
}

</style>
